import { Cell } from 'common/src/designSystem/components/table/cell';
import { VolunteerRegistrationFragment } from 'common/src/generated/types';
import * as React from 'react';
import { TeamMembers } from '../../../teams/teamMembers';

interface IVolunteerRegistrationTeamMembersCellProps {
    volunteerRegistration: VolunteerRegistrationFragment;
}

export const VolunteerRegistrationTeamMembersCell = (
    props: IVolunteerRegistrationTeamMembersCellProps
) => {
    const teamMembers = React.useMemo(
        () =>
            (props.volunteerRegistration.userInfo.formsUsersInfos || []).flatMap(
                (fui) => fui.teamMembers || []
            ),
        [props.volunteerRegistration]
    );

    return (
        <Cell>
            <TeamMembers teamMembers={teamMembers} />
        </Cell>
    );
};
